import {IYPSProductFamiliesRequest} from '@telstra-connect/mobile-data-usage-meter/state/yps-product-families'
import moment from 'moment'
import {QueryClient} from '@tanstack/react-query'
export const reactQueryClient = new QueryClient()
export const setDefaultMenuItem = (value) => {
  window.localStorage.setItem('selectedMenuItem', value)
}

export const getExisitngTemporarySuspensionNumberFromSession = (mobileNumber: string) => {
  const temporarySuspensionItems = sessionStorage.getItem('srmTemporarySuspensionItems')
  if (temporarySuspensionItems && temporarySuspensionItems.length) {
    const temporarySuspensionNumbers = JSON.parse(temporarySuspensionItems)
    if (temporarySuspensionNumbers && temporarySuspensionNumbers.length) {
      return temporarySuspensionNumbers.find((item) => item.includes(mobileNumber))
    }
  }
}

export const updateTemporarySuspensionSessionItems = (mobileNumber: string) => {
  const temporarySuspensionItems = sessionStorage.getItem('srmTemporarySuspensionItems')
  const temporarySuspensionStorage = getExisitngTemporarySuspensionNumberFromSession(mobileNumber)
  if (!temporarySuspensionStorage) {
    if (temporarySuspensionItems && temporarySuspensionItems.length) {
      const temporarySuspensionNumbers: string[] = JSON.parse(temporarySuspensionItems)
      temporarySuspensionNumbers.push(mobileNumber)
      sessionStorage.setItem(
        'srmTemporarySuspensionItems',
        JSON.stringify(temporarySuspensionNumbers),
      )
    } else {
      sessionStorage.setItem('srmTemporarySuspensionItems', JSON.stringify([mobileNumber]))
    }
  }
}
export const removeTemporarySuspensionFromSession = (mobileNumber: string) => {
  const temporarySuspensionItem = getExisitngTemporarySuspensionNumberFromSession(mobileNumber)
  if (temporarySuspensionItem) {
    const temporarySuspensionItems = sessionStorage.getItem('srmTemporarySuspensionItems')
    const temporarySuspensionNumbers = JSON.parse(temporarySuspensionItems)
    const updatedSessionValues = temporarySuspensionNumbers.filter(
      (item) => !item.includes(mobileNumber),
    )
    sessionStorage.setItem('srmTemporarySuspensionItems', JSON.stringify(updatedSessionValues))
  }
}

// Methods for storing, retriveing, removing mobile number of details page in session storage
export const getMobileNumberFromSessionStorage = (storageName: string, mobileNumber: string) => {
  const sessionItems = sessionStorage.getItem(storageName)
  if (sessionItems && sessionItems.length) {
    const values = JSON.parse(sessionItems)
    if (values && values.length) {
      return values.find((item) => item.includes(mobileNumber))
    }
  }
}

export const updateMobileNumberInSessionStorage = (storageName: string, mobileNumber: string) => {
  const sessionItems = sessionStorage.getItem(storageName)
  const isMobileNumberAlreadyPresent = getMobileNumberFromSessionStorage(storageName, mobileNumber)
  if (!isMobileNumberAlreadyPresent) {
    if (sessionItems && sessionItems.length) {
      const mobileNumbers: string[] = JSON.parse(sessionItems)
      mobileNumbers.push(mobileNumber)
      sessionStorage.setItem(storageName, JSON.stringify(mobileNumbers))
    } else {
      sessionStorage.setItem(storageName, JSON.stringify([mobileNumber]))
    }
  }
}
export const removeMobileNumberInSessionStorage = (storageName: string, mobileNumber: string) => {
  const sessionItems = getMobileNumberFromSessionStorage(storageName, mobileNumber)
  if (sessionItems) {
    const items = sessionStorage.getItem(storageName)
    const mobileNumbers = JSON.parse(items)
    const updatedSessionValues = mobileNumbers.filter((item) => !item.includes(mobileNumber))
    sessionStorage.setItem(storageName, JSON.stringify(updatedSessionValues))
  }
}

/* context menu options for mobile services */
export interface IContextMenuOptionProps {
  status: string
  earlyTerminationCharges: string
  mobileCatalogueUrl: string
  adaptiveCatalogue: boolean
  deactivatedDate?: string
}
const getLastDateOfActivation = (date) => {
  const terminationDate = new Date(date)
  terminationDate.setDate(terminationDate.getDate() + 28)
  return terminationDate
}

const hasPassedDueActivationDate = (props) => {
  const isValidTerminationDate = moment(props.deactivatedDate).isValid()

  if (isValidTerminationDate) {
    const today = new Date()
    // passed 28 days
    return today.getTime() > getLastDateOfActivation(props.deactivatedDate).getTime()
  } else {
    return true
  }
}

export const addReactivationItem = (props: IContextMenuOptionProps, contextMenuList) => {
  if (props.status && props.status === 'Deactivated' && !props.mobileCatalogueUrl.length) {
    if (hasPassedDueActivationDate(props)) {
      contextMenuList.push({displayText: 'Reactivate', itemId: 'reactivate-past-due-date-service'})
    } else if (!hasPassedDueActivationDate(props)) {
      contextMenuList.push({displayText: 'Reactivate', itemId: 'reactivate'})
    }
  } else if (
    props.status &&
    props.status === 'Temporarily suspended' &&
    !props.mobileCatalogueUrl.length
  ) {
    if (hasPassedDueActivationDate(props)) {
      contextMenuList.push({displayText: 'Reactivate', itemId: 'reactivate-past-due-date-service'})
    } else if (!hasPassedDueActivationDate(props)) {
      contextMenuList.push({displayText: 'Reactivate', itemId: 'reactivate'})
    }
  }
}
export const addDeactivationItem = (props: IContextMenuOptionProps, contextMenuList) => {
  if (
    ((props.status && props.status === 'Active') ||
      (props.status && props.status === 'Temporarily suspended')) &&
    !props.mobileCatalogueUrl.length
  ) {
    if (
      props.earlyTerminationCharges &&
      props.earlyTerminationCharges.toLowerCase().trim() === 'yes'
    ) {
      contextMenuList.push({displayText: 'Deactivate', itemId: 'deactivate-with-etc'})
    } else {
      contextMenuList.push({displayText: 'Deactivate', itemId: 'deactivate-without-etc'})
    }
  }
}

export const getMobilityCatalogueUrl = (
  ypsProductFamiliesRequest: IYPSProductFamiliesRequest,
  searchForCatelogueSource?: string,
) => {
  let scMobilityCatalogueUrl = ''
  if (ypsProductFamiliesRequest.data && ypsProductFamiliesRequest.data.productFamily) {
    const requiredProductFamily = ypsProductFamiliesRequest.data.productFamily.find(
      (productFamily) => productFamily.key === 'mobility-solutions',
    )
    if (requiredProductFamily) {
      requiredProductFamily.items.forEach((item) => {
        if (item.itemKey === 'request-catalogue') {
          if (!searchForCatelogueSource) {
            scMobilityCatalogueUrl = item.action.url
          } else {
            const subCatPresent =
              item.data.subCategories &&
              item.data.subCategories.length &&
              item.data.subCategories.some((subCat) =>
                subCat.catItemList.some((catItem) => catItem.source === searchForCatelogueSource),
              )
            const catItemPresent =
              item.data.catItemList &&
              item.data.catItemList.length &&
              item.data.catItemList.some((catItem) => catItem.source === searchForCatelogueSource)
            if (subCatPresent || catItemPresent) {
              scMobilityCatalogueUrl = item.action.url
            }
          }
        }
      })
    }
  }
  return scMobilityCatalogueUrl
}
